import { useRef } from 'react';

/**
 * Creates a debounced version of a callback that delays execution until
 * the user has stopped triggering the event for the specified delay.
 */
export default function useDebounce(callback, delay) {
  const timeoutRef = useRef(null);

  return (...args) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      callback(...args);
    }, delay);
  };
}
